export default "__VITE_ASSET__DXOk6XJy__"